import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app/app';
import { appRoutes } from './app/app.routes';
import { AuthInterceptor } from './app/auth/interceptors/auth.interceptor';
import { tokenInterceptorInterceptor } from './app/auth/interceptors/token-interceptor.interceptor';
import { errorInterceptor } from './app/auth/interceptors/error.interceptor';
import { loadingInterceptor } from './app/auth/interceptors/loading.interceptor';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(appRoutes),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([loadingInterceptor, errorInterceptor, tokenInterceptorInterceptor]),
    ),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
}).catch((err) => console.error(err));
